import React from 'react';
import { connect } from 'react-redux';

import {
  incidentDetailsFetchChannelEvidencesTypes,
  incidentDetailsFetchContentLinkData,
  incidentDetailsFetchContentLinkEvidences,
  incidentDetailsFetchContentLinkMetaData,
  incidentDetailsSearchContentLinkAccount,
  incidentDetailsSetContentLinkCommonLinkData,
  incidentDetailsSetContentLinkEvidence,
  incidentDetailsSetContentLinkImages,
  incidentDetailsSetContentLinkModifiedAccount,
  incidentDetailsSetContentLinkMultimediaFile,
  incidentDetailsSetContentLinkOfferListing,
  incidentDetailsSetContentLinkOverallMultimedia,
  incidentDetailsSetContentLinkPriceList,
  incidentDetailsSetContentLinkProductListing,
  incidentDetailsSetContentLinkSeller,
  incidentDetailsSetContentLinkSocialMedia,
  incidentDetailsSetContentLinkValidationAccount,
  incidentDetailsSetContentLinkValidationCommonLinkData,
  incidentDetailsSetContentLinkValidationEvidence,
  incidentDetailsSetContentLinkValidationLinkImageList,
  incidentDetailsSetContentLinkValidationLinkPriceList,
  incidentDetailsSetContentLinkValidationMultimediaFile,
  incidentDetailsSetContentLinkValidationOfferListing,
  incidentDetailsSetContentLinkValidationOverallMultimedia,
  incidentDetailsSetContentLinkValidationProductListing,
  incidentDetailsSetContentLinkValidationSeller,
  incidentDetailsSetContentLinkValidationSocialMedia,
} from '../../../actions/incidentDetailsActions';
import {
  getIncidentDetailsContentAdLinks,
  getIncidentDetailsContentLinkAccountModified,
  getIncidentDetailsContentLinkData,
  getIncidentDetailsContentLinkEnforcementStatus,
  getIncidentDetailsContentLinkEvidenceIsMandatory,
  getIncidentDetailsContentLinkEvidences,
  getIncidentDetailsContentLinkEvidencesIsLoading,
  getIncidentDetailsContentLinkMetaData,
  getIncidentDetailsContentLinkMonitorData,
  getIncidentDetailsContentLinkSearchAccountIsLoading,
  getIncidentDetailsContentLinkSearchAccountStatus,
  getIncidentDetailsContentLinkSeller,
  getIncidentDetailsIncidentData,
} from '../../../reducers/reporting/incidentDetails';
import IncidentDetailsLinkDataContent from './IncidentDetailsLinkDataContent';

const IncidentDetailsContentLinkContent = ({
  accountData,
  adLinks,
  contentLinkEnforcementStatus,
  evidenceData,
  evidenceIsMandatory,
  evidencesIsLoading,
  incidentData,
  incidentDetailsSearchContentLinkAccount,
  incidentDetailsSetContentLinkCommonLinkData,
  incidentDetailsSetContentLinkEvidence,
  incidentDetailsSetContentLinkImages,
  incidentDetailsSetContentLinkModifiedAccount,
  incidentDetailsSetContentLinkMultimediaFile,
  incidentDetailsSetContentLinkOfferListing,
  incidentDetailsSetContentLinkOverallMultimedia,
  incidentDetailsSetContentLinkPriceList,
  incidentDetailsSetContentLinkProductListing,
  incidentDetailsSetContentLinkSeller,
  incidentDetailsSetContentLinkSocialMedia,
  incidentDetailsSetContentLinkValidationAccount,
  incidentDetailsSetContentLinkValidationCommonLinkData,
  incidentDetailsSetContentLinkValidationEvidence,
  incidentDetailsSetContentLinkValidationLinkImageList,
  incidentDetailsSetContentLinkValidationLinkPriceList,
  incidentDetailsSetContentLinkValidationMultimediaFile,
  incidentDetailsSetContentLinkValidationOfferListing,
  incidentDetailsSetContentLinkValidationOverallMultimedia,
  incidentDetailsSetContentLinkValidationProductListing,
  incidentDetailsSetContentLinkValidationSeller,
  incidentDetailsSetContentLinkValidationSocialMedia,
  isSearchLoading,
  linkData,
  linkMetadata,
  monitorData,
  searchStatus,
  sellerData,
}) => {
  const handleCommonLinkDataChange = commonLinkData =>
    incidentDetailsSetContentLinkCommonLinkData({ commonLinkData });

  const handleCommonLinkDataValidate = isValid =>
    incidentDetailsSetContentLinkValidationCommonLinkData({ isValid });

  const handleLinkImageListLinkDataChange = images =>
    incidentDetailsSetContentLinkImages({ images });

  const handleLinkImageListLinkDataValidate = isValid =>
    incidentDetailsSetContentLinkValidationLinkImageList({ isValid });

  const handleLinkPriceListChange = priceList =>
    incidentDetailsSetContentLinkPriceList({ priceList });

  const handleLinkPriceListValidate = isValid =>
    incidentDetailsSetContentLinkValidationLinkPriceList({ isValid });

  const handleMultimediaFileChange = multiMediaFile =>
    incidentDetailsSetContentLinkMultimediaFile({ multiMediaFile });

  const handleMultimediaFileValidate = isValid =>
    incidentDetailsSetContentLinkValidationMultimediaFile({ isValid });

  const handleOfferListingChange = offerListing =>
    incidentDetailsSetContentLinkOfferListing({ offerListing });

  const handleOfferListingValidate = isValid =>
    incidentDetailsSetContentLinkValidationOfferListing({ isValid });

  const handleOverallMultimediaLinkDataChange = overallMultimedia =>
    incidentDetailsSetContentLinkOverallMultimedia({ overallMultimedia });

  const handleOverallMultimediaLinkDataValidate = isValid =>
    incidentDetailsSetContentLinkValidationOverallMultimedia({ isValid });

  const handleProductListingChange = productListing =>
    incidentDetailsSetContentLinkProductListing({ productListing });

  const handleProductListingValidate = isValid =>
    incidentDetailsSetContentLinkValidationProductListing({ isValid });

  const handleSocialMediaLinkDataChange = socialMedia =>
    incidentDetailsSetContentLinkSocialMedia({ socialMedia });

  const handleSocialMediaLinkDataValidate = isValid =>
    incidentDetailsSetContentLinkValidationSocialMedia({ isValid });

  const handleEvidenceValidate = isValid =>
    incidentDetailsSetContentLinkValidationEvidence({ isValid });

  const handleEvidenceChange = evidence =>
    incidentDetailsSetContentLinkEvidence({ evidence });

  const handleSellerLinkDataChange = seller =>
    incidentDetailsSetContentLinkSeller({ seller });

  const handleSellerLinkDataValidate = isValid =>
    incidentDetailsSetContentLinkValidationSeller({ isValid });

  const handleAccountLinkDataChange = account =>
    incidentDetailsSetContentLinkModifiedAccount({ account });

  const handleAccountLinkDataValidate = isValid =>
    incidentDetailsSetContentLinkValidationAccount({ isValid });

  const handleContentLinkAccountSearch = account =>
    incidentDetailsSearchContentLinkAccount({ account });

  return (
    <IncidentDetailsLinkDataContent
      adLinks={adLinks}
      accountData={accountData}
      accountLinkDataChange={handleAccountLinkDataChange}
      accountLinkDataValidate={handleAccountLinkDataValidate}
      commonLinkDataChange={handleCommonLinkDataChange}
      commonLinkDataValidate={handleCommonLinkDataValidate}
      enforcementStatus={contentLinkEnforcementStatus}
      evidenceChange={handleEvidenceChange}
      evidenceData={evidenceData}
      evidenceIsMandatory={evidenceIsMandatory}
      evidenceValidate={handleEvidenceValidate}
      evidencesIsLoading={evidencesIsLoading}
      linkData={linkData}
      linkId={incidentData.contentLink?.contentLinkId}
      linkImageListLinkDataChange={handleLinkImageListLinkDataChange}
      linkImageListLinkDataValidate={handleLinkImageListLinkDataValidate}
      linkInfo={incidentData.contentLink}
      linkMetadata={linkMetadata}
      linkPriceListChange={handleLinkPriceListChange}
      linkPriceListValidate={handleLinkPriceListValidate}
      monitorData={monitorData}
      multimediaFileLinkDataChange={handleMultimediaFileChange}
      multimediaFileLinkDataValidate={handleMultimediaFileValidate}
      offerListingChange={handleOfferListingChange}
      offerListingValidate={handleOfferListingValidate}
      overallMultimediaChange={handleOverallMultimediaLinkDataChange}
      overallMultimediaValidate={handleOverallMultimediaLinkDataValidate}
      priority={incidentData.contentLink?.priority}
      productListingChange={handleProductListingChange}
      productListingValidate={handleProductListingValidate}
      sellerData={sellerData}
      sellerLinkDataChange={handleSellerLinkDataChange}
      sellerLinkDataValidate={handleSellerLinkDataValidate}
      socialMediaLinkDataChange={handleSocialMediaLinkDataChange}
      socialMediaLinkDataValidate={handleSocialMediaLinkDataValidate}
      isSearchLoading={isSearchLoading}
      onSearch={handleContentLinkAccountSearch}
      searchStatus={searchStatus}
    />
  );
};

const mapStateToProps = state => ({
  accountData: getIncidentDetailsContentLinkAccountModified(state),
  adLinks: getIncidentDetailsContentAdLinks(state),
  contentLinkEnforcementStatus: getIncidentDetailsContentLinkEnforcementStatus(
    state
  ),
  evidenceData: getIncidentDetailsContentLinkEvidences(state),
  evidenceIsMandatory: getIncidentDetailsContentLinkEvidenceIsMandatory(state),
  evidencesIsLoading: getIncidentDetailsContentLinkEvidencesIsLoading(state),
  incidentData: getIncidentDetailsIncidentData(state),
  linkData: getIncidentDetailsContentLinkData(state),
  linkMetadata: getIncidentDetailsContentLinkMetaData(state),
  sellerData: getIncidentDetailsContentLinkSeller(state),
  monitorData: getIncidentDetailsContentLinkMonitorData(state),
  searchStatus: getIncidentDetailsContentLinkSearchAccountStatus(state),
  isSearchLoading: getIncidentDetailsContentLinkSearchAccountIsLoading(state),
});

export default connect(mapStateToProps, {
  incidentDetailsFetchChannelEvidencesTypes,
  incidentDetailsFetchContentLinkData,
  incidentDetailsFetchContentLinkEvidences,
  incidentDetailsFetchContentLinkMetaData,
  incidentDetailsSearchContentLinkAccount,
  incidentDetailsSetContentLinkCommonLinkData,
  incidentDetailsSetContentLinkEvidence,
  incidentDetailsSetContentLinkImages,
  incidentDetailsSetContentLinkModifiedAccount,
  incidentDetailsSetContentLinkMultimediaFile,
  incidentDetailsSetContentLinkOfferListing,
  incidentDetailsSetContentLinkOverallMultimedia,
  incidentDetailsSetContentLinkPriceList,
  incidentDetailsSetContentLinkProductListing,
  incidentDetailsSetContentLinkSeller,
  incidentDetailsSetContentLinkSocialMedia,
  incidentDetailsSetContentLinkValidationAccount,
  incidentDetailsSetContentLinkValidationCommonLinkData,
  incidentDetailsSetContentLinkValidationEvidence,
  incidentDetailsSetContentLinkValidationLinkImageList,
  incidentDetailsSetContentLinkValidationLinkPriceList,
  incidentDetailsSetContentLinkValidationMultimediaFile,
  incidentDetailsSetContentLinkValidationOfferListing,
  incidentDetailsSetContentLinkValidationOverallMultimedia,
  incidentDetailsSetContentLinkValidationProductListing,
  incidentDetailsSetContentLinkValidationSeller,
  incidentDetailsSetContentLinkValidationSocialMedia,
})(IncidentDetailsContentLinkContent);
